"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortBidList = void 0;
var utils_1 = require("./utils");
var compareUpdatedAt = function (aMeta, bMeta, order) {
    var aVal = (0, utils_1.getNumberMetaValue)('updated-at-meta', aMeta) ||
        (0, utils_1.getNumberMetaValue)('added-meta', aMeta) ||
        0;
    var bVal = (0, utils_1.getNumberMetaValue)('updated-at-meta', bMeta) ||
        (0, utils_1.getNumberMetaValue)('added-meta', bMeta) ||
        0;
    return (aVal - bVal) * order;
};
var comparePublishedAt = function (aMeta, bMeta, order) {
    var aVal = (0, utils_1.getNumberMetaValue)('published-at-meta', aMeta) || 0;
    var bVal = (0, utils_1.getNumberMetaValue)('published-at-meta', bMeta) || 0;
    return (aVal - bVal) * order;
};
var sortBidList = function (orderBy, orderStr) { return function (a, b) {
    var order = orderStr === 'asc' ? 1 : -1;
    var aMeta = (0, utils_1.getMeta)(a);
    var bMeta = (0, utils_1.getMeta)(b);
    switch (orderBy) {
        case 'name':
            var aName = (0, utils_1.getColumnText)('name', a);
            var bName = (0, utils_1.getColumnText)('name', b);
            return aName.localeCompare(bName) * order;
        case 'status': {
            var sa = (0, utils_1.getColumnText)('status', a);
            var sb = (0, utils_1.getColumnText)('status', b);
            return sa.localeCompare(sb) * order;
        }
        case 'description': {
            var metaA = (0, utils_1.getColumnText)('description', a);
            var metaB = (0, utils_1.getColumnText)('description', b);
            return metaA.localeCompare(metaB) * order;
        }
        case 'id':
            return (a[orderBy] - b[orderBy]) * order;
        case 'updatedAt': {
            return compareUpdatedAt(aMeta, bMeta, order);
        }
        case 'publishedAt': {
            return comparePublishedAt(aMeta, bMeta, order);
        }
        case 'default':
            var aStatus = (0, utils_1.getStringMetaValue)('bid-status-meta', aMeta);
            var bStatus = (0, utils_1.getStringMetaValue)('bid-status-meta', bMeta);
            if (aStatus === 'Draft' && bStatus === 'Draft') {
                return compareUpdatedAt(aMeta, bMeta, order);
            }
            if (aStatus === 'Published' && bStatus === 'Published') {
                return comparePublishedAt(aMeta, bMeta, order);
            }
            if (aStatus === 'Draft' && bStatus === 'Published') {
                return -1;
            }
            if (aStatus === 'Published' && bStatus === 'Draft') {
                return 1;
            }
            return 0;
        default:
            return 0;
    }
}; };
exports.sortBidList = sortBidList;
